import * as h2Api from '../h2Api'

export const LOAD_APPROVAL_PROFILE = 'LOAD_APPROVAL_PROFILE'
export const APPROVAL_PROFILE = 'APPROVAL_PROFILE'

export const loadProfileForApproval = id => dispatch => {
  return dispatch(
    h2Api.get(`/profiles/admin/approve/${id}`)({ type: LOAD_APPROVAL_PROFILE })
  )
}

export const approveProfile = id => dispatch => {
  return dispatch(
    h2Api.post(`/profiles/admin/approve/${id}`, {})({ type: APPROVAL_PROFILE })
  )
}
